/*=========================================================================================
  File Name: betGetters.js
  Description: bet getters
==========================================================================================*/

export default {

}
